import React from 'react'
import AnalyticsPage from './Analytics/AnalyticsPage'

export default function Analytics(): React.ReactElement {
  return <AnalyticsPage />
}
